import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import * as PayableTripActions from '../actions/payable-trips.actions';
import * as UiActions from '../../ui/actions/ui.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { PaymentsService } from '../services/payroll.service';
import { EmployeeShift, Payroll, PayrollTrip } from '../models/payroll.model';

@Injectable()
export class PayableTripEffects {
    constructor(private actions$: Actions, private paymentService: PaymentsService, private store: Store<AppState>) { }

   
    loadPayableTrips$ = createEffect(() => this.actions$.pipe(
        ofType(PayableTripActions.loadPayableTrips),
        mergeMap(({ organizationId, clientId, payrollId, weekNumber, isApproved }) => this.paymentService.getPayableTrips(organizationId, clientId, payrollId, weekNumber, isApproved).pipe(
            map((payableTrips: PayrollTrip[]) => {
                return PayableTripActions.loadPayableTripsSuccess({ payableTrips });
            }),
            catchError(error => of( /* handle error action */))
        )
        )
    )
    );

    loadEmployeeShifts$ = createEffect(() => this.actions$.pipe(
        ofType(PayableTripActions.loadEmployeeShifts),
        mergeMap(({ organizationId, startDate, endDate }) =>
            this.paymentService.getEmployeeShifts(organizationId, startDate, endDate).pipe(
                map((employeeShifts: EmployeeShift[]) =>
                    PayableTripActions.loadEmployeeShiftsSuccess({ employeeShifts })
                ),
                catchError(error => of(UiActions.serviceCallFailure({
                    action: PayableTripActions.loadEmployeeShifts, error
                })))
            )
        )
    ));

    createEmployeeShift$ = createEffect(() => this.actions$.pipe(
        ofType(PayableTripActions.createEmployeeShift),
        mergeMap(({ organizationId, clientId, employeeId, startTime, endTime }) =>
            this.paymentService.createEmployeeShift(organizationId, clientId, employeeId, startTime, endTime).pipe(
                map((employeeShift: EmployeeShift) =>
                    PayableTripActions.createEmployeeShiftSuccess({ employeeShift })
                ),
                catchError(error => of(UiActions.serviceCallFailure({
                    action: PayableTripActions.createEmployeeShift, error
                })))
            )
        )
    ));

    updatePayableTrip$ = createEffect(() => this.actions$.pipe(
        ofType(PayableTripActions.updatePayableTrip),
        mergeMap(({ organizationId, clientId, payrollId, tripId, trip }) =>
            this.paymentService.updatePayableTrip(organizationId, clientId, payrollId, tripId, trip).pipe(
                map(() => PayableTripActions.updatePayableTripSuccess({ tripId, trip })),
                catchError(error => of(UiActions.serviceCallFailure({
                    action: PayableTripActions.updatePayableTrip, error
                })))
            )
        )
    ));
}
